<!--  -->
<template>
  <div>
    <div class="step-container">
      <!-- <el-steps :active="isActive"  :class="isActive == isActive + 1 ? stepActive : 'stepActive'">
        <el-step title="选择分类" class="Active">
          <i class="step01" slot="icon">1</i>
        </el-step>
        <el-step title="编辑商品基本信息" class="Active">
          <i class="step02" slot="icon">2</i>
        </el-step>
        <el-step title="编辑商品详细信息" class="Active">
          <i class="step03" slot="icon">3</i>
        </el-step>
        <el-step title="提交审核" class="Active">
          <i class="step04" slot="icon">4</i>
        </el-step>
        <el-step title="发布完成" class="Active">
          <i class="step05" slot="icon">5</i>
        </el-step>
      </el-steps> -->
      <el-steps :active="isActive" finish-status="success" align-center>
        <el-step title="选择商品分类"></el-step>
        <el-step
          :title="chooseFlag ? '选择保供平台商品数据' : '编辑商品基本信息'"
        ></el-step>
        <el-step title="编辑商品详细信息"></el-step>
        <el-step title="提交审核"></el-step>
        <el-step title="发布完成"></el-step>
      </el-steps>
      <!-- 
      <el-steps :active="isActive">
        <el-step v-for="(value, index) in milepost"
          :class="isActive == index + 1 ? stepActive : 'stepActive'"
          :title="value.title"
          :key="index"
          class="Active"
        > 
        </el-step>
      </el-steps> -->
    </div>
    <keep-alive>
      <first
        v-if="isActive == 0 && !chooseFlag"
        @changeStep="changeStep"
      ></first>
      <first-by-supplier
        v-if="isActive == 0 && chooseFlag"
        @changeStep="changeStep"
      ></first-by-supplier>
      <choose-products v-if="isActive == 1 && chooseFlag" />
      <second v-if="isActive == 1 && !chooseFlag"></second>
      <third v-if="isActive == 2 && salesType === 1"></third>
      <offstandardProduct
        v-if="isActive === 2 && salesType === 2"
      ></offstandardProduct>
    </keep-alive>
  </div>
</template>

<script>
import first from './createProductsFirst.vue';
import second from './createProductsSec.vue';
import third from './createProductsThird.vue';
import offstandardProduct from './createOffstandardProductsThird.vue';
import bus from '../../../../../components/common/bus';
import ChooseProducts from './components/chooseProducts.vue';
import firstBySupplier from './createProductsFirstBySupplier.vue';

export default {
  components: {
    first,
    second,
    third,
    ChooseProducts,
    firstBySupplier,
    offstandardProduct,
  },
  data() {
    return {
      isActive: 0,
      //     milepost: [
      //   {title: '选择分类'},
      //   {title: '编辑商品基本信息'},
      //   {title: '编辑商品详细信息'},
      //   {title: '提交审核'},
      //   {title: '发布完成'},
      // ],
      // 动态添加类名
      stepActive: 'stepActive',
      chooseFlag: '',
      salesType: null,
    };
  },

  computed: {
    // salesType() {
    //   console.log('%c red', 'color:red', this.$getStore('salesType'));
    //   return Number(this.$getStore('salesType'));
    // },
  },

  created() {
    // this.salesType = Number(this.$getStore('salesType'));
    this.chooseFlag = this.$route.query.productAuditId;
    bus.$on('changeStep', (val) => {
      console.log(val);
      this.isActive = val;
      this.salesType = Number(this.$getStore('salesType'));
    });
    bus.$on('handleBack', (val) => {
      console.log(val);
      this.isActive = val;
    });
  },
  methods: {
    changeStep(options) {
      this.isActive = options;
    },
  },
};
</script>
<style lang="scss" scoped>
.step-container {
  margin: 20px 52px;
}
.el-step ::v-deep .el-step__title {
  font-size: 14px;
}
// .el-step__head ::v-deep.el-step__icon{
//   width: 30px;
//   height: 30px;
// }
::v-deep .Active {
  .el-step__head {
    .el-step__icon {
      width: 30px;
      height: 30px;
    }
  }
}
::v-deep .stepActive {
  .el-step__head.is-finish {
    .el-step__icon.is-text {
      background: #2587ff;
      color: #fff;
    }
  }
}
::v-deep .step01,
.step02,
.step03,
.step04,
.step05 {
  width: 14px;
  height: 10px;
  background-size: 100% 100%;
}
.step-container ::v-deep .el-step__head.is-success .el-step__icon.is-text {
  width: 30px;
  height: 30px;
  background: #2587ff;
  border: 0;
}
.step-container ::v-deep .el-step__title.is-success {
  color: #2587ff;
}
.step-container ::v-deep .el-step__title.is-success.el-step__icon-inner {
  color: #2587ff;
}
.step-container ::v-deep .el-step__head.is-process .el-step__icon.is-text {
  width: 30px;
  height: 30px;
  background: #2587ff;
  border: 0;
  color: #fff;
}
.step-container ::v-deep .el-step__head.is-wait .el-step__icon.is-text {
  width: 30px;
  height: 30px;
  background: #d9d9d9;
  border: 1px solid #d9d9d9;
  color: #fff;
}
::v-deep .el-step__title.is-success {
  color: #2587ff !important;
}
::v-deep .el-step__head.is-success {
  color: #fff;
  border-color: #2587ff;
}
::v-deep .el-step.is-horizontal .el-step__line {
  height: 1px;
}
// .step01{
//   background-image:url("../../../../../assets/img/step01.png");
// }
// .step02{
//   background-image:url("../../../../../assets/img/step02.png");
// }
// .step03{
//   background-image:url("../../../../../assets/img/step03.png");
// }
// .step04{
//   background-image:url("../../../../../assets/img/step04.png");
// }
// .step05{
//   background-image:url("../../../../../assets/img/step05.png");
// }
//  ::v-deep .el-steps{
//   // width:80%;
//   .el-step__head.is-process{
//     border-color:#dedede;
//   }
//   .el-step__head.is-finish{
//     border-color:#2587FF;
//   }

//   .el-step__title.is-finish{
//     color:#285edf;
//   }
//   .el-step__icon{
//     width:30px;
//     height:30px;
//   }
//   .is-finish .step01{
//     background-image:url("../../../../../assets/img/cancel.png");
//   }
//   .is-finish .step02{
//     background-image:url("../../../../../assets/img/cancel.png");
//   }
//     .is-finish .step03{
//     background-image:url("../../../../../assets/img/cancel.png");
//   }
//   .is-finish .step04{
//     background-image:url("../../../../../assets/img/cancel.png");
//   }
//   .is-finish .step05{
//     background-image:url("../../../../../assets/img/cancel.png");
//   }
// }
</style>
